export default __webpack_public_path__ + "static/media/elevate-lav-3.e4bc2ee1.png";